import { render, staticRenderFns } from "./cv-file-uploader.vue?vue&type=template&id=20df6240&"
import script from "./cv-file-uploader.vue?vue&type=script&lang=js&"
export * from "./cv-file-uploader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports